import {FeatureConfig} from '@/config/featureToggles'
import {accessRulesParsing, getValuesWithAccess} from '@/helpers/accessRules'
import {FeatureToggle, setFeatureFlagOnStorage} from '@/helpers/featureToggle'
import {isSUT} from '@/utils/env'

export const getCountries = () => {
  const countriesByEnv = import.meta.env[FeatureConfig.countries] as string
  if (!countriesByEnv) throw new Error(`${FeatureConfig.countries} is not defined`)

  const countriesByStorage = isSUT() ? sessionStorage.getItem(FeatureConfig.countries) : null

  const countries = (countriesByStorage ?? countriesByEnv).split(',').map(country => country.trim())
  if (isSUT()) {
    // during testing, do not filter by access rules
    return countries
  }
  const [, accessCountries] = accessRulesParsing()
  return getValuesWithAccess(countries, accessCountries)
}

export const getApplications = () => {
  const applicationsByEnv = import.meta.env[FeatureConfig.applications] as string
  if (!applicationsByEnv) throw new Error(`${FeatureConfig.applications} is not defined`)

  const applications = applicationsByEnv.split(',').map(application => application.trim())
  if (isSUT()) {
    return applications
  }

  const [accessApplications] = accessRulesParsing()
  return getValuesWithAccess(applications, accessApplications)
}

const setDefaultValues = () => {
  Object.values(FeatureToggle).forEach(key => {
    setFeatureFlagOnStorage(key, import.meta.env[key] === 'true')
  })
}
setDefaultValues()
